<<template>
  <div class="detail-panel">
    <div class="btn-panel">
        <a v-if="this.action != 'View'" class="btn btn-default" @click="save">{{$rs["btn_save"]}}</a>
      <slot></slot>
    </div>
    <hr>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["codeKey"]}}</span>
          <input type="text" class="form-control" v-bind:readonly='action=="View"' v-model="data.codeKey">
        </div>
    </div>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["codeValue"]}}</span>
          <input type="text" class="form-control" v-bind:readonly='action=="View"' v-model="data.codeValue">
        </div>
    </div>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["param0"]}}</span>
          <input type="text" class="form-control" v-bind:readonly='action=="View"' v-model="data.param0">
        </div>
    </div>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["param1"]}}</span>
          <input type="text" class="form-control" v-bind:readonly='action=="View"' v-model="data.param1">
        </div>
    </div>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["param2"]}}</span>
          <input type="text" class="form-control" v-bind:readonly='action=="View"' v-model="data.param2">
        </div>
    </div>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["param3"]}}</span>
          <input type="text" class="form-control" v-bind:readonly='action=="View"' v-model="data.param3">
        </div>
    </div>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["param4"]}}</span>
          <input type="text" class="form-control" v-bind:readonly='action=="View"' v-model="data.param4">
        </div>
    </div>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["param5"]}}</span>
          <input type="text" class="form-control" v-bind:readonly='action=="View"' v-model="data.param5">
        </div>
    </div>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["codeDesc"]}}</span>
          <input type="text" class="form-control" v-bind:readonly='action=="View"' v-model="data.codeDesc">
        </div>
    </div>  
  </div>
</template>

<<script>
import mixin from "../../mixin/detailMixin.js";
export default {
  methods: {
    checkInput(){
      if (!this.checkNull(this.data.codeKey, "nullKey")) return false
      if (!this.checkNull(this.data.codeValue, "nullValue")) return false
      return true 
    }
  },
  mixins:[mixin]
}
</script>
